<template>
  <div class="space-y-6">
    <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-6">
      <h3 class="text-lg font-medium font-poppins text-gray-900 dark:text-gray-100 mb-4">
        Business Metrics
      </h3>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <UiControl id="metrics-call-frequency" label="Call Frequency Preference">
          <UiSelect
            id="metrics-call-frequency-select"
            v-model="form.call_frequency"
            :options="callFrequencyOptions"
          />
        </UiControl>
        <UiControl id="metrics-num-locations" label="Number of Locations">
          <UiInput v-model="form.num_locations" type="number" placeholder="1" />
        </UiControl>
        <UiControl id="metrics-client-spend" label="Client Spend">
          <div class="relative">
            <span class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm">$</span>
            <UiInput v-model="form.client_spend" type="number" placeholder="0" class="pl-7" />
          </div>
        </UiControl>
        <UiControl id="metrics-closing-ratio" label="Closing Ratio">
          <div class="relative">
            <UiInput v-model="form.closing_ratio" type="number" placeholder="0" />
            <span class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm">%</span>
          </div>
        </UiControl>
        <UiControl id="metrics-avg-ticket" label="Average Ticket / LTV">
          <div class="relative">
            <span class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm">$</span>
            <UiInput v-model="form.avg_ticket" type="number" placeholder="0" class="pl-7" />
          </div>
        </UiControl>
      </div>
    </div>

    <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-6">
      <h3 class="text-lg font-medium font-poppins text-gray-900 dark:text-gray-100 mb-4">
        Services
      </h3>
      <div class="space-y-4">
        <UiControl id="metrics-services-offered" label="Services Offered">
          <UiTextarea v-model="form.services_offered" placeholder="List the services this business provides..." />
        </UiControl>
        <UiControl id="metrics-services-not-offered" label="Services Not Offered">
          <UiTextarea v-model="form.services_not_offered" placeholder="List any services this business does NOT provide..." />
        </UiControl>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import UiControl from '~/javascript/components/ui/form/control/control.vue'
import UiInput from '~/javascript/components/ui/form/input/input.vue'
import UiSelect from '~/javascript/components/ui/form/select/select.vue'
import UiTextarea from '~/javascript/components/ui/form/textarea/textarea.vue'

const props = defineProps({
  stepKey: { type: String, required: true },
  label: { type: String, required: true },
  onboarding: { type: Object, required: true },
  mode: { type: String, required: true }
})

const callFrequencyOptions = [
  { id: 'weekly', title: 'Weekly' },
  { id: 'biweekly', title: 'Bi-weekly' },
  { id: 'monthly', title: 'Monthly' },
  { id: 'quarterly', title: 'Quarterly' }
]

const form = ref({
  call_frequency: '',
  num_locations: '',
  client_spend: '',
  closing_ratio: '',
  avg_ticket: '',
  services_offered: '',
  services_not_offered: ''
})

onMounted(() => {
  const d = props.onboarding.seo_detail || {}
  form.value.call_frequency = d.call_frequency || ''
  form.value.num_locations = d.num_locations || ''
  form.value.client_spend = d.client_spend || ''
  form.value.closing_ratio = d.closing_ratio || ''
  form.value.avg_ticket = d.avg_ticket || ''
  form.value.services_offered = d.services_offered || ''
  form.value.services_not_offered = d.services_not_offered || ''
})

defineExpose({
  getData: () => ({ ...form.value })
})
</script>
